module.exports = __webpack_public_path__ + "static/media/main_logo.d01221a0.png";